import { filterBy } from '@progress/kendo-data-query';
import { Button } from '@progress/kendo-react-buttons';
import { Field, Form, FormElement} from '@progress/kendo-react-form';
import {
  FormDatePicker,
  FormInput,
  FormMultiSelect,
  
} from 'commons/forms/form';
import { required } from 'commons/forms/validators';
import React, { useState } from 'react';

export default function BannerItem(props) {
  const { bin, path, remove, save} = props;

  const referenceValidator = (e) => required(e, 'Référence');
  const dateDebutValidator = (e) => required(e, 'Date début');
  const dateFinValidator = (e) => required(e, 'Date de fin');

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <span
        onClick={() => remove(path)}
        style={{ fontSize: '20px', alignSelf: 'end', marginRight: '10px' }}
        className="k-icon k-font-icon k-i-close"
      />

      <Form
        initialValues={{
          title: '',
          description: '',
          src: '',
          texte_color: '#000000',
          dateLimite: new Date(),
          dateDebut: new Date(),
          type: 'hits',
          path: path,
          bin: bin,
          created_at: new Date()
        }}
        onSubmit={save}
        render={(formRenderProps) => (
          <FormElement>
            <fieldset className={'k-form-fieldset'}>
              <div className="row">
                <div className="col-md-6">
                  <img
                    style={{
                      height: '23rem',
                      margin: 'auto',
                      display: 'block',
                    }}
                    alt={path.split('.')[0]}
                    src={'data:image/png;base64,' + bin}
                  />
                </div>
                <div className="col-md-6">
                  
                  <div className="row">
                    
                    <div className="col-md-12">
                      <Field
                        id={'title'}
                        name={'title'}
                        label={'Title'}
                        component={FormInput}
                        wrapperStyle={{
                          marginRight: '18px',
                        }}
                        validator={referenceValidator}
                      />
                      <Field
                        id={'description'}
                        name={'description'}
                        label={'Description'}
                        component={FormInput}
                        wrapperStyle={{
                          marginRight: '18px',
                        }}
                        validator={referenceValidator}
                      />
                      <Field
                        id={'src'}
                        name={'src'}
                        label={'Référence click'}
                        component={FormInput}
                        wrapperStyle={{
                          marginRight: '18px',
                        }}
                        validator={referenceValidator}
                      />
                      <Field
                        id={'dateDebut '}
                        name={'dateDebut'}
                        label={'Date début'}
                        component={FormDatePicker}
                        validator={dateDebutValidator}
                        wrapperStyle={{
                          minWidth: '10rem',
                          width: '12%',
                          marginRight: '15px',
                        }}
                      />
                      <Field
                        id={'dateLimite'}
                        name={'dateLimite'}
                        label={'Date limite'}
                        component={FormDatePicker}
                        validator={dateFinValidator}
                        wrapperStyle={{
                          minWidth: '10rem',
                          width: '12%',
                          marginRight: '15px',
                        }}
                      />
                      <div className="k-form-buttons">
                        <Button
                          style={{ backgroundColor: '#538199' }}
                          type={'submit'}
                        >
                          Enregistrer
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </FormElement>
        )}
      />

      <div
        style={{
          height: '1px',
          backgroundColor: 'lightgray',
          margin: '25px 0 5px 0',
        }}
      ></div>
    </div>
  );
}
